module.exports = __webpack_public_path__ + "media/images/custom_page/tempest/gacha-gift-491415c642976b810a37b686429e4c22.png";